var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormGeneric',_vm._b({},'FormGeneric',_vm.formConfig,false))
}
var staticRenderFns = []

export { render, staticRenderFns }